// If new options are added, please make sure to update the analytics switch found here.. src\components\atoms\section-divider\index.jsx
const sectionDividerOptions = {
  performance: { label: 'Performance & Risk', id: 'performance-risk' },
  allocation: { label: 'Allocation', id: 'allocation' },
  characteristics: { label: 'Characteristics', id: 'characteristics' },
  resources: { label: 'Resources', id: 'resources' }
};

export default sectionDividerOptions;
